export const lightPrimary = {
  contrast: '#ffffff',
  dark: '#032612',
  light: '#50fa66',
  main: '#2da44e'
};

export const lightSecondary = {
  contrast: '#ffffff',
  dark: '#032612',
  light: '#50fa66',
  main: '#2da44e'
};

export const lightError = {
  contrast: '#ffffff',
  dark: '#a53531',
  light: '#ef6f6b',
  main: '#ec4c47'
};

export const lightWarning = {
  contrast: '#ffffff',
  dark: '#975b1e',
  light: '#e09b55',
  main: '#d9822b'
};

export const lightInfo = {
  contrast: '#ffffff',
  dark: '#0b4e8d',
  light: '#3f8cd4',
  main: '#1070CA'
};

export const lightSuccess = {
  contrast: '#ffffff',
  dark: '#1b774d',
  light: '#52bb8b',
  main: '#27AB6E'
};

export const lightBackground = {
  default: '#f2f5f4',
  paper: '#ffffff'
};

export const lightText = {
  primary: '#03060b',
  secondary: '#506176'
};

export const lightNeutral = {
  100: '#edfaef',
  200: '#d1ded3',
  300: '#a7b8aa',
  400: '#94b099',
  500: '#76917b',
  600: '#4f7055',
  700: '#334a37',
  800: '#1b261d',
  900: '#111712',
  1000: '#2BA44E'
};

export const darkPrimary = {
  contrast: '#ffffff',
  dark: '#032612',
  light: '#50fa66',
  main: '#38B248'
};

export const darkSecondary = {
  contrast: '#ffffff',
  dark: '#032612',
  light: '#50fa66',
  main: '#38B248'
};

export const darkError = {
  contrast: '#ffffff',
  dark: '#85372b',
  light: '#eb6d57',
  main: '#e6492d'
};

export const darkWarning = {
  contrast: '#ffffff',
  dark: '#8D682d',
  light: '#f7bb57',
  main: '#f6ab2e'
};

export const darkInfo = {
  contrast: '#ffffff',
  dark: '#1D4580',
  light: '#4483df',
  main: '#1664d8'
};

export const darkSuccess = {
  contrast: '#ffffff',
  dark: '#2F6b39',
  light: '#5fc16d',
  main: '#38b249'
};

export const darkBackground = {
  default: '#111318',
  paper: '#111318'
};

export const darkText = {
  primary: '#d8dade',
  secondary: '#868998'
};

export const darkNeutral = {
  100: '#121c13',
  200: '#313828',
  300: '#4b5243',
  400: '#606659',
  500: '#717a67',
  600: '#939c89',
  700: '#adb5a5',
  800: '#c5c9c1',
  900: '#e0e3dc',
  1000: '#2BA44E'
};
